export default {
  name: 'Field',
  props: {
    label: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'l',
      validator: (value) => {
        return ['m', 'l'].indexOf(value) !== -1;
      },
    },
    error: Boolean,
    errorMessage: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    required: Boolean,
    disable: Boolean,
    focused: Boolean,
    pill: Boolean,
    showLabel: {
      type: Boolean,
      default: true,
    },
    hideLabelOnFocus: Boolean,
    animLabel: {
      type: Boolean,
      default: true,
    },
    stackLabel: {
      type: Boolean,
      default: false,
    },
    hideControl: {
      type: Boolean,
      default: true,
    },
    indent: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fieldClasses() {
      return {
        'field--disabled': this.disable,
        'field--errored': this.error,
        'field--focused': this.focused,
        'field--pill': this.pill,
        'field--hide-label-on-focus': this.hideLabelOnFocus,
        'field--anim-label': this.isAnimLabel,
        'field--not-indented': !this.indent,
      };
    },
    isErrorVisible() {
      return this.error && (this.errorMessage || this.$slots.slotError);
    },
    isHintVisible() {
      return this.hint || this.$slots.slotHint;
    },
    hasLabel() {
      return this.$props.label && this.showLabel;
    },
    isAnimLabel() {
      return this.hasLabel &&
        ((this.animLabel && this.focused) || this.stackLabel);
    },
  },
};
